import { Container, Row, Col } from "react-bootstrap";
import { Facebook, Twitter, Instagram, Linkedin } from "react-bootstrap-icons";

const Footer = () => {
  return (
    <footer
      className="py-4"
      style={{
        background: "linear-gradient(135deg, #2c3e50, #1a1a2e)",
        color: "#fff",
      }}
    >
      <Container>
        <Row className="g-4">
          <Col md={4} className="mb-3 mb-md-0">
            <h3 className="h5 mb-2 fw-bold">SARL AGORA GLOBAL</h3>
            <p className="text-light small">
              Solutions technologiques innovantes pour votre entreprise.
            </p>
          </Col>
          <Col md={4} className="mb-3 mb-md-0">
            <h3 className="h5 mb-2 fw-bold">Contact</h3>
            <ul className="list-unstyled text-light small">
              <li>Email: sales@sarlagoraglobal.dz</li>
              <li>Tél: +21328111147</li>
              <li>Adresse: Alger, Said hamedine</li>
            </ul>
          </Col>
          <Col md={4}>
            <h3 className="h5 mb-2 fw-bold">Suivez-nous</h3>
            <div className="d-flex gap-3">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-light">
                <Facebook size={20} className="hover-scale" />
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-light">
                <Twitter size={20} className="hover-scale" />
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-light">
                <Instagram size={20} className="hover-scale" />
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-light">
                <Linkedin size={20} className="hover-scale" />
              </a>
            </div>
          </Col>
        </Row>
        <div className="text-center text-light mt-3 pt-3 border-top">
          <p className="mb-0 small">
            <span>© 2025 SARL AGORA GLOBAL, Inc. Tous droits réservés.</span>
          </p>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;
